import { ApiResponse, TicketManagerTicket } from '@vision/ui/interfaces';
import { normalizeTicketManagerTicketsResponse, TicketManagerTicketApi } from '../../ticket-manager.service.utils';

export function normalizeTicketManagerTicketListResponse(
  response: ApiResponse<TicketManagerTicketApi[]>,
): ApiResponse<TicketManagerTicket[]> {
  return normalizeTicketManagerTicketsResponse(response);
}
